import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import config from './config.json';

const Step99 = ({ prevStep }) => {
  return (
    <Container>
      <Row className="mb-3">
        <Col lg={6} offset-lg={3}>
          <h3>{config.step99.step}</h3>
          <p>{config.step99.text}</p>
        </Col>
      </Row>
      {/* <Row className="mt-3">
        <Col>
          <Button type="button" variant="secondary" onClick={prevStep}>
            Retour
          </Button>
        </Col>
      </Row> */}
    </Container>
  );
};

export default Step99;

